import React from "react";
import StatisticsCard from "../../Components/Ui/StaticsCard/StaticCard";
import { FaFirstOrder, FaProductHunt, FaUser } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import {  Col, Row } from "reactstrap";
import { useGetHome } from "../../api/home";
import { Spin } from "antd";

export default function HomePage() {
  const { t } = useTranslation();
  
  const {data,isLoading} = useGetHome()
  console.log(data);
  

  const cardsData = [
    {
      icon: <FaUser className="warning" size={20} />,
      count: data?.developer_count, // Example count
      pathWhenClick: '/',
      titleKey: "developer_count",
      contentKey: "developer_in_your_Application"
    },
    {
      icon: <FaProductHunt className="warning" size={20} />,
      count: data?.contact_us_count, // Example count
      pathWhenClick: "/",
      titleKey: "contact_us_count",
      contentKey: "contact_us__Count_in_your_Application"
    },
    {
      icon: <FaFirstOrder className="warning" size={20} />,
      count: data?.quotation_count, // Example count
      pathWhenClick: "/",
      titleKey: "quotation_count",
      contentKey: "quotation_count_in_your_Application"
    }
  ];

  if(isLoading){
    return <Spin/>
  }
  return (
    <>
      <Row xs={1} sm={1} md={1} lg={3} xl={3}>
        {cardsData.map((card, index) => (
          <Col key={index} style={{ padding: "0.5rem" }}>
            <div style={{ cursor: "pointer" }}>
              <StatisticsCard
                pathWhenClick={card.pathWhenClick}
                icon={card.icon}
                count={`${card.count ?? 1}`}
                CardContent={t(`You_have`) + "  " + ((card.count) ?? 1) + "  " + t(card.contentKey)}
                CardTitle={t(card.titleKey)}
              />
            </div>
          </Col>
        ))}
      </Row>
    </>
  );
}
